import styled from 'styled-components';

const fontColor = {
  blue: '#1b7bdd',
  green: '#1ba39c',
  filledBlue: '#fff',
  filledGreen: '#fff',
};

const bgColor = {
  blue: 'transparent',
  green: 'transparent',
  filledBlue: '#1b7bdd',
  filledGreen: '#1ba39c',
};

const borderColor = {
  blue: '#1b7bdd',
  green: '#1ba39c',
  filledBlue: '#1b7bdd',
  filledGreen: '#1ba39c',
};

const hoverBgColor = {
  blue: '#1b7bdd',
  green: '#1ba39c',
  filledBlue: '#165ca3',
  filledGreen: '#1a746f',
};

const hoverBorderColor = {
  blue: '#1b7bdd',
  green: '#1ba39c',
  filledBlue: '#165ca3',
  filledGreen: '#1a746f',
};

const defaultPosition = {
  center: 'center',
  start: 'flex-start',
  end: 'flex-end',
};

export const Wrapper = styled.div`
  height: fit-content;
  width: 100%;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: ${({ position }) => defaultPosition[position]};
`;

export const Button = styled.button`
  color: ${({ color }) => fontColor[color]};
  border-color: ${({ color }) => borderColor[color]};
  background-color: ${({ color }) => bgColor[color]};
  border-width: 1px;
  border-style: solid;
  border-radius: 9999px;
  min-width: 13.5rem;
  min-height: 2.5rem;
  font-family: ${({ dir }) =>
    dir === 'rtl' ? 'GESSTwoDWTCMedium,sans-serif ' : 'DINMediumAlternate '};
  font-size: ${({ dir }) => (dir === 'rtl' ? '14px' : '0.75rem')};
  padding: 0.625rem 1.25rem;
  cursor: pointer;
  letter-spacing: ${({ dir }) => (dir === 'rtl' ? '0' : '1.29px')};
  line-height: 1.5;
  text-transform: uppercase;
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 400ms;
  margin: 3rem 0 0;

  @media (max-width: 575.98px) {
    margin: 2rem 0 0;
  }

  &:hover {
    background-color: ${({ color }) => hoverBgColor[color]};
    border-color: ${({ color }) => hoverBorderColor[color]};
    color: #fff;
  }
`;
